/* eslint-disable no-extra-boolean-cast */
/* eslint-disable prefer-template */
import { GET_MY, REQUEST_DATA_RESULT } from '../../containers/App/constants';
import {
  REQUEST_TRANSPORT_ORDER_CREATE,
  REQUEST_TRANSPORT_ORDER_EDIT,
  REQUEST_TRANSPORT_ORDERS,
  REQUEST_TRANSPORT_ORDER,
  REQUEST_TRANSPORT_ORDER_FILTER,
  UPDATE_TRANSPORT_ORDER_SEARCH_STRING,
  UPDATE_TRANSPORT_ORDER_FILTERS,
  REQUEST_TRANSPORT_ORDER_FILTER_RESET,
  SET_TRANSPORT_ORDERS_SORT,
  APPLY_TRANSPORT_ORDER_FILTERS,
  REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE,
  REQUEST_VEHICLE_TRANSPORT_ORDERS,
  INITIATE_TRANSPORT_ORDER_CREATE,
  INITIATE_TRANSPORT_ORDER_EDIT,
  SET_NEW_TRANSPORT_ORDER_VALUE,
  REQUEST_DELETE_TRANSPORT_ORDER,
  ADD_TRANSPORT_ORDER_TO_BULK_ACTIONS_LIST,
  REMOVE_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST,
  REMOVE_ALL_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST,
  REQUEST_UPDATE_SELECTED_TRANSPORT_ORDERS,
  REQUEST_CREATE_TRANSPORT_ORDER_BULK_ACTION,
  APPLY_TRANSPORT_ORDER_FILTERS_SEPARATE_LIST,
  SWITCH_OVERVIEW_SCREEN_MODE,
  SET_FILTER_COMBINATION,
  DELETE_TRANSPORT_ORDER_TRANSPORTER,
  DELETE_TRANSPORT_ORDER_PROPERTY,
} from './constants';
import { formatAmount, formatFinancialAmounts } from './helpers';

export function fetchTransportOrders(offset = 0, limit = 200) {
  return {
    type: REQUEST_TRANSPORT_ORDER_FILTER,
  };
}

export function deleteTransportOrder(transportOrderId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_DELETE_TRANSPORT_ORDER,
    gate: REQUEST_DELETE_TRANSPORT_ORDER + transportOrderId,
    delete: {},
    path: `transport-orders/${transportOrderId}`,
    putOnComplete: [fetchTransportOrders()],
    callback,
  };
}

export function fetchTransportOrder(transportOrderId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_TRANSPORT_ORDER,
    transportOrderId,
    work: [REQUEST_TRANSPORT_ORDER, `${REQUEST_TRANSPORT_ORDER}-${transportOrderId}`],
    gate: REQUEST_TRANSPORT_ORDER + transportOrderId,
    path: `transport-orders/${transportOrderId}`,
    callback,
  };
}

export function fetchVehicleTransportOrders(vehicleId, text, offset = 0, callback) {
  let path = `transport-orders/?offset=${offset}&limit=${10}${text ? `&text=${text}` : ''}`;
  path += `&filters[${0}][key]=vehicleId&filters[${0}][type]=single&filters[${0}][value][${0}]=${vehicleId}`;
  return {
    type: GET_MY,
    id: REQUEST_VEHICLE_TRANSPORT_ORDERS,
    work: REQUEST_VEHICLE_TRANSPORT_ORDERS,
    gate: REQUEST_VEHICLE_TRANSPORT_ORDERS,
    path,
    callback,
  };
}

export function applyTransportOrderFilters() {
  return {
    type: APPLY_TRANSPORT_ORDER_FILTERS,
  };
}

export function changeTransportOrderFilter(name, value, options = {}) {
  return {
    type: REQUEST_TRANSPORT_ORDER_FILTER,
    name,
    value,
    ...options,
  };
}

export function setTransportOrdersSort(sortType, order, option = {}) {
  return {
    type: SET_TRANSPORT_ORDERS_SORT,
    sortType,
    order,
    ...option,
  };
}

export function resetTransportOrderFilter(options = {}) {
  return {
    type: REQUEST_TRANSPORT_ORDER_FILTER_RESET,
    ...options,
  };
}

export function updateTransportOrderFilter(propertyFilter, options) {
  return {
    type: UPDATE_TRANSPORT_ORDER_FILTERS,
    propertyFilter,
    ...options,
  };
}

export function updateWithFetchTransportOrderFilter(propertyFilter, options) {
  return {
    type: REQUEST_TRANSPORT_ORDER_FILTER,
    propertyFilter,
    options: {
      skipFilter: true,
    },
  };
}

export function updateSearchString(searchString) {
  return {
    type: UPDATE_TRANSPORT_ORDER_SEARCH_STRING,
    searchString,
  };
}

export function transportOrdersSearch(text, callback) {
  let path = `transport-orders/getList`;

  const searchParams = {
    offset: 0,
    limit: 50,
    text,
    filters: [],
  };

  return {
    type: GET_MY,
    work: REQUEST_TRANSPORT_ORDERS,
    gate: REQUEST_TRANSPORT_ORDERS,
    path,
    post: searchParams,
    callback,
  };
}

export function changeTransportOrderPropertyFilter(propertyFilter, options) {
  return {
    type: REQUEST_TRANSPORT_ORDER_FILTER,
    propertyFilter,
    ...options,
  };
}

export function setFilterCombination(properties, combination, options) {
  return {
    type: SET_FILTER_COMBINATION,
    combination,
    properties,
    ...options,
  };
}

export function setNewTransportOrderValue(name, value) {
  return {
    type: SET_NEW_TRANSPORT_ORDER_VALUE,
    name,
    value,
  };
}

export function initiateNewTransportOrderValue(name) {
  return {
    type: SET_NEW_TRANSPORT_ORDER_VALUE,
    name,
    initiate: true,
  };
}

export function initiateTransportOrderEdit(id) {
  return {
    type: INITIATE_TRANSPORT_ORDER_EDIT,
    id,
  };
}

export function initiateTransportOrderCreate() {
  return {
    type: INITIATE_TRANSPORT_ORDER_CREATE,
  };
}

export function setTransportOrderProperties(id, dto, callback) {
  let work = REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE;
  if (dto?.remarks) work = `${REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE}-remarks`;
  return {
    type: GET_MY,
    put: {
      id,
      ...dto,
    },

    work: work,
    gate: REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE + id,
    callback,
    path: `transport-orders/${id}`,
    putOnComplete: [fetchTransportOrder(id)],
  };
}

export function createTransportOrder(dto, callback) {
  return {
    type: GET_MY,

    post: dto,
    work: REQUEST_TRANSPORT_ORDER_CREATE,
    gate: REQUEST_TRANSPORT_ORDER_CREATE,
    path: `transport-orders`,
    callback,
  };
}

export function editTransportOrder(id, dto, callback) {
  return {
    type: GET_MY,

    put: dto,
    work: REQUEST_TRANSPORT_ORDER_EDIT,
    gate: REQUEST_TRANSPORT_ORDER_EDIT,
    path: `transport-orders/${id}`,
    callback,
  };
}

// TRANSPORT ORDERS BULK ACTIONS
export function addTransportOrderToBulkActionsList(transportOrder) {
  return {
    type: ADD_TRANSPORT_ORDER_TO_BULK_ACTIONS_LIST,
    payload: transportOrder,
  };
}

export function removeTransportOrderFromBulkActionsList(transportOrderId) {
  return {
    type: REMOVE_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST,
    transportOrderId,
  };
}

export function removeAllTransportOrdersFromBulkActionsList(callback) {
  return {
    type: REMOVE_ALL_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST,
    callback,
  };
}

export function updateSelectedTransportOrders(ids, dto, callback) {
  return {
    type: GET_MY,
    put: {
      ids: ids,
      ...dto,
    },
    work: REQUEST_UPDATE_SELECTED_TRANSPORT_ORDERS,
    gate: REQUEST_UPDATE_SELECTED_TRANSPORT_ORDERS,
    callback,
    path: `/transport-orders/bulk-update`,
    putOnComplete: [fetchTransportOrders()],
  };
}

export function createTransportOrderBulkAction(vehicleIds, dto, callback) {
  return {
    type: GET_MY,
    put: {
      vehicleIds: vehicleIds,
      payload: dto,
    },
    work: REQUEST_CREATE_TRANSPORT_ORDER_BULK_ACTION,
    gate: REQUEST_CREATE_TRANSPORT_ORDER_BULK_ACTION,
    callback,
    path: `/transport-orders/bulk-create`,
    putOnComplete: [fetchTransportOrders()],
  };
}

// Split, double screen view
export function applyTransportOrderSeparateListFilters() {
  return {
    type: APPLY_TRANSPORT_ORDER_FILTERS_SEPARATE_LIST,
  };
}

export function switchOverviewScreenMode() {
  return {
    type: SWITCH_OVERVIEW_SCREEN_MODE,
  };
}

export function deleteTransportOrderTransporter(transportOrderId, callback) {
  let work = REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE + '-' + 'deleteTransporter';
  return {
    type: GET_MY,
    put: { id: +transportOrderId },

    work: work,
    gate: REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE + transportOrderId,
    id: DELETE_TRANSPORT_ORDER_TRANSPORTER,
    callback,
    path: `/transport-orders/transporter/delete`,
    putOnComplete: [fetchTransportOrder(transportOrderId)],
  };
}
